module.exports = __webpack_public_path__ + "static/media/curso-sushi.b29f88fb.png";